import axios from 'axios'

const http = axios.create({
  // baseURL: 'http://localhost:3000'
  baseURL: 'https://i35jjks2ie.execute-api.us-east-1.amazonaws.com/hom'
})

http.defaults.headers.authorization = (localStorage["auth.access_token"] ? "Bearer " + JSON.parse(localStorage["auth.access_token"]) : '')

export default http